export default "__VITE_ASSET__DUP5ys$E__"